(function ($, Promise) {

		var STATE_ALLRIGHT = 2;
		var STATE_WARNING = 3;
		var STATE_OUT = 4;
		var STATE_COLLISION = 5;

		// Constructor
		function SkillGamesGame2(renderer, parent) {

			this.parent = parent;

			this.playerInteractionAllowed = false;
			this.totaltime = 0;
			this.playerRadius = 75;
			this.currentLevel = -1;
			this.currentTries = 0;
			this.shaking = false;
			this.stopped = true;
			this.mouseDown = false;

			this.dangers = [];
			this.dangersShown = false;

			this.levels = [
				{
					name: "1",
					duration: 20000,
					speed: 0.75,
					tries: 3,
					ennemiesCount: 2,
				},
				{
					name: "2",
					duration: 20000,
					speed: 1,
					tries: 3,
					ennemiesCount: 3,
				},
				{
					name: "3",
					duration: 20000,
					speed: 1.25,
					tries: 3,
					ennemiesCount: 4,
				}
			];

			this.ennemies = [
				{
					name: "ennemy1",
					width: 150,
					height: 150,
					graphic: false,
					speed: {},
					initialSpeed: {
						x: +5,
						y: -5,
					},
					initialPosition: {
						x: +150,
						y: -150,
					}
				},
				{
					name: "ennemy2",
					width: 60,
					height: 200,
					graphic: false,
					speed: {},
					initialSpeed: {
						x: -6,
						y: +6,
					},
					initialPosition: {
						x: -185,
						y: +175,
					}
				},
				{
					name: "ennemy3",
					width: 150,
					height: 150,
					graphic: false,
					speed: {},
					initialSpeed: {
						x: -7,
						y: -7,
					},
					initialPosition: {
						x: -175,
						y: -150,
					}
				},
				{
					name: "ennemy4",
					width: 60,
					height: 200,
					graphic: false,
					speed: {},
					initialSpeed: {
						x: +4,
						y: +4,
					},
					initialPosition: {
						x: +150,
						y: +150,
					}
				},
			];

			this.state = false;
			this.renderer = renderer;
			this.stage = new PIXI.Container();
			this.ticker = new PIXI.Ticker();
			// Create a container
			this.container = new PIXI.Container();
			this.stage.addChild(this.container);

			// Create line background
			// this.backgroundGraphics = new PIXI.Graphics();
			// this.backgroundGraphics.beginFill(0xb8b7b7);
			// var lineWidth = 50;
			// var lineSpacing = 100;
			// var lineCount = 28;
			// var lineAngleOffset = 960;
			// for (var i2 = 0; i2 < lineCount; i2++) {
			// 	var points = [];
			// 	points.push(new PIXI.Point((i2 * lineSpacing) - 960, 0));
			// 	points.push(new PIXI.Point((i2 * lineSpacing) - 960 + lineWidth, 0));
			// 	points.push(new PIXI.Point((i2 * lineSpacing) - 960 + lineAngleOffset + lineWidth, 1080));
			// 	points.push(new PIXI.Point((i2 * lineSpacing) - 960 + lineAngleOffset, 1080));
			// 	this.backgroundGraphics.drawPolygon(points);
			// }
			// this.container.addChild(this.backgroundGraphics);

			// Add background
			this.bgTexture = PIXI.Texture.from('images/skill_games/spatial/spatial-bg.png');
			this.bgSprite = new PIXI.Sprite(this.bgTexture);
			this.bgSprite.width = 2100;
			this.bgSprite.height = 1080;
			this.bgSprite.position.x = -50
			this.container.addChild(this.bgSprite);

			// Add warining background
			this.bgWarningTexture = PIXI.Texture.from('images/skill_games/spatial/spatial-warning-bg.png');
			this.bgWarningSprite = new PIXI.Sprite(this.bgWarningTexture);
			this.bgWarningSprite.width = 2100;
			this.bgWarningSprite.height = 1080;
			this.bgWarningSprite.position.x = -50
			this.bgWarningSprite.alpha = 0;
			this.container.addChild(this.bgWarningSprite);

			var safezoneSize = {width: 990, height: 660}
			var warningSize = {width: safezoneSize.width + 100, height: safezoneSize.height + 100}
			var bounceZoneSize = {width: safezoneSize.width + 200, height: safezoneSize.height + 200}

			// Create warining zone background
			this.bounceZoneGraphic = new PIXI.Graphics();
			this.bounceZoneGraphic.beginFill(0xCCCCCC);
			this.bounceZoneGraphic.drawRect(-bounceZoneSize.width / 2, -bounceZoneSize.height / 2, bounceZoneSize.width, bounceZoneSize.height);
			this.bounceZoneGraphic.x = 1920 / 2;
			this.bounceZoneGraphic.y = 1080 / 2 + 50;
			this.bounceZoneGraphic.alpha = 0;
			this.container.addChild(this.bounceZoneGraphic);

			// Create warining zone background
			this.warningGraphic = new PIXI.Graphics();
			this.warningGraphic.filters = [new PIXI.filters.ColorOverlayFilter(0x93c9df)];
			this.warningGraphic.beginFill(0xFFFFFF);
			this.warningGraphic.drawRoundedRect(-warningSize.width / 2, -warningSize.height / 2, warningSize.width, warningSize.height, 40);
			this.warningGraphic.x = 1920 / 2;
			this.warningGraphic.y = 1080 / 2 + 50;
			this.container.addChild(this.warningGraphic);

			// Create warining zone background
			this.safezoneGraphic = new PIXI.Graphics();
			this.safezoneGraphic.beginFill(0xFFFFFF);
			this.safezoneGraphic.drawRect(-safezoneSize.width / 2, -safezoneSize.height / 2, safezoneSize.width, safezoneSize.height);
			this.safezoneGraphic.x = 1920 / 2;
			this.safezoneGraphic.y = 1080 / 2 + 50;
			this.container.addChild(this.safezoneGraphic);

			// Danger signs
			var textureDanger = PIXI.Texture.from('images/skill_games/spatial/danger.png');
			for (var i = 0; i < 2; i++) {
				this.dangers[i] = new PIXI.Sprite(textureDanger);
				this.dangers[i].anchor.set(0.5);
				this.dangers[i].x = (i == 0) ? 210 : 1710;
				this.dangers[i].y = 1080 / 2 + 30;
				this.dangers[i].alpha = 0;
				this.container.addChild(this.dangers[i]);
			}

			// Create enemmies
			for (var i = 0; i < this.ennemies.length; i++) {
				this.ennemies[i].graphic = new PIXI.Graphics();
				this.ennemies[i].graphic.beginFill(0xa70237);
				this.ennemies[i].graphic.drawRect(-this.ennemies[i].width / 2, -this.ennemies[i].height / 2, this.ennemies[i].width, this.ennemies[i].height);
				this.container.addChild(this.ennemies[i].graphic);
			}

			// Player
			this.dude = new PIXI.Container();
			this.dude.x = 1920 / 2;
			this.dude.y = 1080 / 2 + 50;
			this.dude.interactive = true;
			this.dude.buttonMode = true;
			this.container.addChild(this.dude);

			var dudeNormal = new PIXI.Graphics();
			dudeNormal.beginFill(0x1fbfe3);
			dudeNormal.drawCircle(0, 0, this.playerRadius);
			this.dude.addChild(dudeNormal);

			var dudeDangerTexture = PIXI.Texture.from('images/skill_games/spatial/shaky-dude.svg');
			var dudeDanger = new PIXI.Sprite(dudeDangerTexture);
			dudeDanger.anchor.set(0.5);
			dudeDanger.scale.set(0.5);
			dudeDanger.alpha = 0;
			this.dude.addChild(dudeDanger);

			this.dude.on('pointerdown', $.proxy(function () {
				console.log("pointerdown")
				this.mouseDown = true;
			}, this));

			this.dude.on('pointerup', $.proxy(function () {
				console.log("pointerup")
				this.mouseDown = false;
			}, this));


			// Listen for animate update
			this.ticker.add($.proxy(this.draw, this));

			// Listen for touch event
			$("#game-canvas").on("touchmove mousemove", $.proxy(this.touchemove, this))

		}

		SkillGamesGame2.prototype.start = function () {
			this.state = true;
			this.startLevel(0);
			this.ticker.start();
		}

		SkillGamesGame2.prototype.stop = function () {
			this.ticker.stop();
			this.state = false;
			this.clearTimerUpdate();
		}

		SkillGamesGame2.prototype.touchemove = function (e) {

			if (this.stopped) {
				return;
			}

			// Reset screensaver timer
			this.parent.resetTimer();

			var x, y;
			if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
				var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
				x = touch.pageX;
				y = touch.pageY;
			} else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover' || e.type == 'mouseout' || e.type == 'mouseenter' || e.type == 'mouseleave') {
				x = e.clientX;
				y = e.clientY;
			}

			if (!this.mouseDown) {
				return;
			}

			this.dude.x = x;
			this.dude.y = y;

		}

		SkillGamesGame2.prototype.draw = function (delta) {

			if (!this.stopped) {

				var bounceZoneBounds = this.bounceZoneGraphic.getBounds();
				var state = STATE_ALLRIGHT;

				for (var i = 0; i < this.ennemies.length; i++) {

					// Skip ennemies not shown on this level
					if (i >= this.levels[this.currentLevel].ennemiesCount) {
						break;
					}

					// Update posisiton
					this.ennemies[i].graphic.x += this.ennemies[i].speed.x * delta * this.levels[this.currentLevel].speed;
					this.ennemies[i].graphic.y += this.ennemies[i].speed.y * delta * this.levels[this.currentLevel].speed;

					// Update Horizontal speed if offset
					if ((this.ennemies[i].speed.x < 0 && this.ennemies[i].graphic.x < bounceZoneBounds.left) || (this.ennemies[i].speed.x > 0 && this.ennemies[i].graphic.x > bounceZoneBounds.right)) {
						this.ennemies[i].speed.x *= -1;
					}

					// Update Vertical speed if offset
					if ((this.ennemies[i].speed.y < 0 && this.ennemies[i].graphic.y < bounceZoneBounds.top) || (this.ennemies[i].speed.y > 0 && this.ennemies[i].graphic.y > bounceZoneBounds.bottom)) {
						this.ennemies[i].speed.y *= -1;
					}

					// Check collisions
					if (!this.checkCollision(this.dude.x, this.dude.y, 0, this.warningGraphic, 1.075) && state < STATE_COLLISION) {
						state = STATE_COLLISION;
						// this.ennemies[i].graphic.alpha = 0.5;
					} else if (!this.checkCollision(this.dude.x, this.dude.y, this.playerRadius, this.safezoneGraphic, 0.75) && state < STATE_WARNING) {
						// WARNING
						state = STATE_WARNING;
					} else if (this.checkCollision(this.dude.x, this.dude.y, this.playerRadius, this.ennemies[i].graphic)) {
						// Collision with ennemy
						state = STATE_COLLISION;
					}

				}

				// Check collisions
				if (state == STATE_OUT) {
					// OUT
					console.log("OUT")
					this.warningGraphic.filters[0].color = 0xf5d435;
					this.shake(0.5, 0.5);
					this.toggleDudeShake(true);
					this.fail();
				} else if (state == STATE_COLLISION) {
					// Collision with ennemy
					console.log("COLLISION")
					this.shake(0.5, 0.5);
					this.toggleDudeShake(true);
					this.fail();
				} else if (state == STATE_WARNING) {
					// WARNING
					this.warningGraphic.filters[0].color = 0xf5d435;
					this.shake(0.5, 0.2);
					this.toggleDanger(true);
					this.toggleDudeShake(true);
				} else {
					// Alright
					this.toggleDanger(false);
					this.toggleDudeShake(false);
					this.warningGraphic.filters[0].color = 0x93c9df;
				}
			}

			// Rotate element
			this.dude.getChildAt(1).rotation += delta * 0.03;

			// Trigger rendering
			this.renderer.render(this.stage);
		}

		SkillGamesGame2.prototype.checkCollision = function (x, y, radius, graphic, sizeFactor) {

			// var bounds = graphic.getBounds();
			// if (this.dude.x > bounds.left - radius &&
			// 	this.dude.x < bounds.right + radius &&
			// 	this.dude.y > bounds.top - radius &&
			// 	this.dude.y < bounds.bottom + radius) {
			// 	return true;
			// }
			// return false;

			var sizeFactor = (typeof sizeFactor == "undefined") ? 1 : sizeFactor;

			// http://www.jeffreythompson.org/collision-detection/circle-rect.php
			var cx = x;
			var cy = y;
			var rx = graphic.x;
			var ry = graphic.y;
			var rw = graphic.width * sizeFactor;
			var rh = graphic.height * sizeFactor;

			// temporary variables to set edges for testing
			var testX = cx;
			var testY = cy;

			// which edge is closest?
			if (cx < rx - rw / 2) testX = rx - rw / 2;      // test left edge
			else if (cx > rx + rw / 2) testX = rx + rw / 2;   // right edge
			if (cy < ry - rh / 2) testY = ry - rh / 2;      // top edge
			else if (cy > ry + rh / 2) testY = ry + rh / 2;   // bottom edge

			// get distance from closest edges
			var distX = cx - testX;
			var distY = cy - testY;
			var distance = Math.sqrt((distX * distX) + (distY * distY));

			// if the distance is less than the radius, collision!
			if (distance <= radius) {
				return true;
			}
			return false;
		}

		SkillGamesGame2.prototype.fail = function () {
			this.stopped = true;
			this.currentTries += 1;
			this.clearTimerUpdate();

			// Save current time
			this.totaltime += Math.floor(((millis() - this.startTime)) / 100) / 10;

			// Animate in
			var tl = new TimelineMax();

			// Fade out level
			this.addFadeOutToTimeline(tl);

			// Callbacks
			if (this.currentTries < this.levels[this.currentLevel].tries) {

				// Try again feedback
				tl.addCallback(function () {
					this.parent.showFeedback("try-again");
				}, "-=1.0", [], this);

				tl.addCallback(function () {
					this.parent.closeFeedback();
					this.startLevel(this.currentLevel);
				}, "+=2.0", [], this);

			} else {
				// TODO HANDLE GAME OVER
				// Feedback
				tl.addCallback(function () {
					$("#game-trigger-2").addClass("failed");
					$("#game-feedback-gameover .level-reached").html((this.currentLevel + 1));
					$("#game-feedback-gameover .total-time").html(Math.floor(this.totaltime) + "&nbsp;" + "sec");
					this.parent.showFeedback("gameover");
				}, "-=1.0", [], this);
			}
		}

		SkillGamesGame2.prototype.addFadeOutToTimeline = function (tl) {

			// Fade out ennemies
			for (var i = 0; i < this.ennemies.length; i++) {
				tl.to(this.ennemies[i].graphic, 0.5, {
					alpha: 0,
					easing: Sine.easeInOut
				}, (i != 0 ? "-=0.25" : "-=0.0"));
			}

			// Fade out dude
			tl.to(this.dude, 0.5, {
				alpha: 0,
				easing: Sine.easeInOut
			}, "-=0.25");
		}

		SkillGamesGame2.prototype.startLevel = function (level) {

			this.currentLevel = level;
			this.startTime = millis();
			this.updateTopBar();
			this.clearTimerUpdate();
			this.toggleDanger(false);
			this.toggleDudeShake(false);

			this.parent.drawTime(1.0);

			// Reset enemmies
			for (var i = 0; i < this.ennemies.length; i++) {

				if (i < this.levels[this.currentLevel].ennemiesCount) {
					// Enable ennemy
					this.ennemies[i].graphic.visible = true;
					this.ennemies[i].graphic.x = 1920 / 2 + this.ennemies[i].initialPosition.x;
					this.ennemies[i].graphic.y = 1080 / 2 + this.ennemies[i].initialPosition.y;
					this.ennemies[i].speed.x = this.ennemies[i].initialSpeed.x;
					this.ennemies[i].speed.y = this.ennemies[i].initialSpeed.y;
				} else {
					// Disable ennemy
					this.ennemies[i].graphic.visible = false;
				}

			}

			// Reset dude
			this.dude.x = 1920 / 2;
			this.dude.y = 1080 / 2 + 50;

			// Reset zone color
			this.warningGraphic.filters[0].color = 0x93c9df;

			// Create animation
			var tl = new TimelineMax();

			// Fade in dude
			tl.fromTo(this.dude, 0.5, {
				alpha: 0,
			}, {
				alpha: 1,
				easing: Sine.easeInOut
			});

			// Fade in ennemies
			for (var i = 0; i < this.ennemies.length; i++) {
				if (i < this.levels[this.currentLevel].ennemiesCount) {
					tl.fromTo(this.ennemies[i].graphic, 0.5, {
						alpha: 0,
					}, {
						alpha: 1,
						easing: Sine.easeInOut
					}, "-=0.25");
				}
			}

			// Restart level
			tl.addCallback(function () {
				this.stopped = false;
				this.startTime = millis();
				this.updateTopBar();
				this.timerUpdate(this.levels[this.currentLevel].duration);
			}, "+=0.5", [], this);

		}

		SkillGamesGame2.prototype.completeLevel = function () {

			this.stopped = true;
			this.clearTimerUpdate();

			// Save current time
			this.totaltime += Math.floor(((millis() - this.startTime)) / 100) / 10;

			// Animate in
			var tl = new TimelineMax();

			// Fade out level
			this.addFadeOutToTimeline(tl);

			// Callbacks
			if (this.currentLevel < (this.levels.length - 1)) {
				// Good work feedback
				tl.addCallback(function () {
					this.parent.showFeedback("good-work");
				}, "-=1.0", [], this);

				tl.addCallback(function () {
					this.currentLevel++;
					this.currentTries = 0;
					this.parent.closeFeedback();
					this.startLevel(this.currentLevel);
				}, "+=2.0", [], this);

			} else {
				// Game fully completed
				console.log("Game fully completed");
				$("#game-trigger-2").addClass("completed")

				// Game completed
				tl.addCallback(function () {
					$("#game-feedback-completed .level-reached").html((this.currentLevel + 1));
					$("#game-feedback-completed .total-time").html(Math.floor(this.totaltime) + "&nbsp;" + "sec");
					this.parent.showFeedback("completed");
				}, "-=1.0", [], this);
			}
		}

		SkillGamesGame2.prototype.timerUpdate = function (duration) {

			// Set inital text
			$("#game-top-bar #game-top-bar-timer .time-left").text(duration / 1000);

			// Start timer
			this.clearTimerUpdate();
			this.timerUpdateInterval = setInterval($.proxy(function (duration) {
				var timeleft = constrain(Math.ceil((duration - (millis() - this.startTime)) / 1000), 0, duration / 1000);
				$("#game-top-bar #game-top-bar-timer .time-left").text(timeleft);
				if (timeleft <= 0) {
					this.clearTimerUpdate();
					this.completeLevel();
				}

				var timeNorm = timeleft / (duration / 1000);
				this.parent.drawTime(timeNorm);

			}, this, duration), 1000);
		}

		SkillGamesGame2.prototype.shake = function (speed, scale) {

			if (this.shaking) {
				return;
			}

			// Animate in
			this.shaking = true;
			var tl = new TimelineMax();
			tl.to(this.container, 0.1 * speed, {
				x: -10 * scale,
				easing: Sine.easeInOut

			});
			tl.to(this.container, 0.2 * speed, {
				x: 10 * scale,
				easing: Sine.easeInOut
			});
			tl.to(this.container, 0.2 * speed, {
				x: -10 * scale,
				easing: Sine.easeInOut
			});
			tl.to(this.container, 0.2 * speed, {
				x: 10 * scale,
				easing: Sine.easeInOut
			});
			tl.to(this.container, 0.2 * speed, {
				x: -10 * scale,
				easing: Sine.easeInOut
			});
			tl.to(this.container, 0.1 * speed, {
				x: 0 * scale,
				easing: Sine.easeInOut
			});
			tl.addCallback(function () {
				this.shaking = false;
			}, "+=0.0", [], this);

		}

		SkillGamesGame2.prototype.toggleDanger = function (toggleValue) {

			if (this.dangersShown == toggleValue) {
				return;
			}

			var tl = new TimelineMax();
			for (var i = 0; i < this.dangers.length; i++) {
				tl.to(this.dangers[i], 0.1, {
					alpha: toggleValue ? 1 : 0,
					easing: Sine.easeInOut
				}, 0);
			}

			tl.to(this.bgWarningSprite, 0.1, {
				alpha: toggleValue ? 1 : 0,
				easing: Sine.easeInOut
			}, 0);

			this.dangersShown = toggleValue;

		}

		SkillGamesGame2.prototype.toggleDudeShake = function (toggleValue) {

			var tl = new TimelineMax();

			tl.to(this.dude.getChildAt(1).scale, 0.1, {
				x: toggleValue ? 0.8 : 0.5,
				y: toggleValue ? 0.8 : 0.5,
				easing: Sine.easeInOut
			}, 0);

			this.dude.getChildAt(1).alpha = toggleValue
		}

		SkillGamesGame2.prototype.updateTopBar = function () {
			$("#game-top-bar").addClass("no-score").removeClass("no-tries no-timer");
			$("#game-top-bar #game-top-bar-timer .time-left").text(Math.ceil(this.levels[this.currentLevel].duration / 1000));
			$("#game-top-bar .current-level").text(this.levels[this.currentLevel].name)
			$("#game-top-bar .current-try").text(this.currentTries + 1);
			$("#game-top-bar .tries-total").text(this.levels[this.currentLevel].tries);
		}

		SkillGamesGame2.prototype.clearTimerUpdate = function () {
			if (this.timerUpdateInterval != false) {
				clearInterval(this.timerUpdateInterval);
				this.timerUpdateInterval = false;
			}
		}

		SkillGamesGame2.prototype.reset = function (screenId) {

			this.playerInteractionAllowed = false;
			this.totaltime = 0;
			this.playerRadius = 75;
			this.currentLevel = -1;
			this.currentTries = 0;
			this.shaking = false;
			this.stopped = true;
			this.mouseDown = false;

			this.clearTimerUpdate();
		}

		// Expose SkillGamesGame2
		window.SkillGamesGame2 = SkillGamesGame2;
	}
)
(jQuery, Promise);
